/**
 * 관리자 콘솔 탭의 스크롤 영역 레이아웃 — 목록 높이를 px로 박지 않고 창 크기를 따라가게 한다.
 *
 * 계약: AdminConsole의 프레임이 창 높이(h-full)를 갖고, 화면 패널이 `flex-1 min-h-0 overflow-y-auto flex flex-col`이다.
 * 화면 머리(제목·설명)는 그 패널 **밖** 위쪽에 고정돼 있다 — 패널 안으로 옮기면 아래 계산이 머리 높이만큼 어긋난다.
 * 그래서 화면 루트가 ADMIN_TAB_FILL이면 패널 높이를 그대로 받고, 그 안의 ADMIN_LIST_FILL 목록이
 * 툴바·폼·배너가 쓰고 남은 높이를 가져간다(툴바가 좁은 폭에서 줄바꿈되면 그만큼 목록이 줄어든다).
 * 예전엔 목록마다 최대 높이가 400px 고정이라 큰 창에서는 아래가 비고, 작은 창에서는 패널과 목록이 이중으로 스크롤됐다.
 */

/** 목록 하나가 주인공인 탭의 루트 — 패널 높이를 받아 목록에 남는 높이를 넘긴다 */
export const ADMIN_TAB_FILL = 'flex-1 min-h-0 flex flex-col';

/**
 * 그 목록 — flex 기본값(0 1 auto)이라 내용 높이에서 출발해 남는 높이까지만 줄어들고 안에서 스크롤한다.
 * 행이 적으면 내용만큼만 차지한다(테두리 있는 목록이 텅 빈 상자로 늘어나지 않는다).
 * 하한 12rem: 창이 아주 낮으면 목록은 하한을 지키고 넘친 만큼 패널이 대신 스크롤한다.
 */
export const ADMIN_LIST_FILL = 'min-h-[12rem] overflow-y-auto';

/** 여러 섹션이 흐르는 탭(공지 발송·원격지원 등)의 보조 목록 — 창 높이에 비례하는 상한 */
export const ADMIN_LIST_CAPPED = 'max-h-[max(12rem,35dvh)] overflow-y-auto';
